module.exports = __webpack_public_path__ + "074881d7efa15c24c26ec15a2474ab72.jpg";